export default __webpack_public_path__ + "static/thank-you-gif-b6bd6c30678bcd8f52f2e2198b3c7cfb.gif";